module.exports = __webpack_public_path__ + "static/media/expired.9e410b1e.svg";